import React from 'react';
import PropTypes from 'prop-types';

import { FlexRow } from 'ui-components/components/flex';

import { getLocationStringEU } from '../../helpers';
import { useAddressFormContext } from '../../context';
import { PhoneLine } from '../../read-only-fields/phone';
import { EmailLink } from '../../read-only-fields/email';
import { AddressLine } from '../../read-only-fields/address-line';
import { Company } from '../../read-only-fields/company';
import { Name } from '../../read-only-fields/name';

export const FRFields = ({ style }) => {
  const { address, recipientInfo } = useAddressFormContext();
  const { name, company = '', phone = '', line1 = '', line2 = '', line3 = '', city = '', postalCode = '', state = '' } = address;
  const { email } = recipientInfo;
  const franceLocation = getLocationStringEU(city, postalCode);

  return (
    <div className={style}>
      <Company company={company} />
      <Name name={name} />
      <AddressLine line={line1} />
      <AddressLine line={line2} />
      <AddressLine line={line3} />
      {franceLocation && <FlexRow>{franceLocation}</FlexRow>}
      {state && <FlexRow>{state}</FlexRow>}
      <FlexRow>France</FlexRow>
      <PhoneLine phone={phone} />
      <EmailLink email={email} />
    </div>
  );
};

FRFields.propTypes = {
  style: PropTypes.string,
};
